// extracted by mini-css-extract-plugin
export default {"UserData":"UserData_UserData__HtPS0","userName":"UserData_userName__AOa5O","extraInfo":"UserData_extraInfo__rSUCz"};